const authHandler = {
  // 组件挂载
  mounted(el: any, binding: any) {
    const userRole = "developer"; // 假设当前用户角色为 'developer'
    const requiredRoles = binding.value; // 获取指令传递的参数（角色数组）

    // 判断当前用户角色是否在所需角色数组中
    if (!requiredRoles.includes(userRole)) {
      el.style.display = "none"; // 隐藏元素
    }
  },
  // 组件卸载
  unmounted() {},
};
(authHandler as any).install = function (app) {
  app.directive("auth", authHandler);
};
export default authHandler;
